import Typography from '@material-ui/core/Typography'
import { styled } from '@material-ui/core/styles'

export const PopoverTypography = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1)
}))
